import IconBase from './IconBase'
import { ReactComponent } from './light/home.svg'

const Icon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default Icon
